export default __webpack_public_path__ + "static/media/node.6b9eedfa.png";